import ChartContainer from '../Services/charts/apex-charts/ChartContainer';

export const GradientArea = ({ title, values = [], subtitles = [], color = '#0D82D3', height = 350 }) => {
    const options = {
        chart: {
            type: 'area',
            height,
            toolbar: {
                show: true
            }
        },
        stroke: {
            curve: 'smooth',
            width: 3
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.45,
                opacityTo: 0.05,
                stops: [0, 90, 100]
            }
        },
        markers: {
            size: 4
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: subtitles,
            labels: {
                style: {
                    fontSize: '14px',
                    colors: '#333'
                }
            }
        },
        yaxis: {
            labels: {
                formatter: (val) => (val || val === 0 ? val.toLocaleString('pt-BR') : '')
            }
        },
        colors: [color],
        tooltip: {
            y: {
                formatter: (val) => val || val === 0 ? Number(val).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, }) : ''
            }
        },
        grid: {
            show: true,
            borderColor: '#e0e0e0'
        },
        legend: {
            show: false
        }
    };

    return (
        <ChartContainer
            title={title}
            options={options}
            series={[{ name: 'Média (dias)', data: values }]}
            type="area"
            height={height}
        />
    );
};
